import { FCX, ID } from '@models';
import Button from '@components/Button';
import DataFallback from '@components/DataFallback';
import React, { useMemo, useState } from 'react';
import { useFiltersContext } from '@core/FiltersContext';
import PlatesSelect from '@components/PlatesSelect';
import EditChainsPopup from '@pages/FoodWatchItem/EditChainsPopup';

const Chains: FCX<{
    value: ID[];
    setValue: (value: ID[]) => void;
}> = ({
    value,
    setValue,
}) => {
    const { options: { chains } } = useFiltersContext();
    const [isPopupOpened, setIsPopupOpened] = useState(false);

    const selectedItems = useMemo(
        () => value.map(id => chains.find(i => i.id === id)!),
        [value, chains]
    );

    return (
        <div className="card">
            <div
                className="card-header is-sticky"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div className="font-medium">
                    Track Chains
                </div>
                <div style={{ display: 'flex' }}>
                    {value.length > 0 && (
                        <Button
                            modifiers={['blue', 'naked']}
                            onClick={() => setValue([])}
                            style={{ marginRight: 10 }}
                        >
                            Reset All Selections
                        </Button>
                    )}
                    <Button
                        modifiers={['blue']}
                        onClick={() => setIsPopupOpened(true)}
                    >
                        EDIT CHAIN SELECTIONS
                    </Button>
                </div>
            </div>
            <div className="card-content">
                {value.length > 0 ? (
                    <PlatesSelect
                        value={[]}
                        options={selectedItems}
                        onOptionClick={(id) => setValue(value.filter(i => i !== id))}
                        isGenericItemWidth
                        isTagDecoration
                    />
                ) : (
                    <DataFallback
                        title=""
                        subTitle="No chains added yet."
                    />
                )}
            </div>
            {isPopupOpened && (
                <EditChainsPopup
                    value={value}
                    setValue={setValue}
                    onClose={() => setIsPopupOpened(false)}
                />
            )}
        </div>
    );
};

export default Chains;